module.exports = __webpack_public_path__ + "img/team-person-3.b55d04ca.png";